import { create } from 'zustand';

import { SsoToken } from '../Types/Auth';

import type KeyCloak from 'keycloak-js';

export interface AuthStore {
    authenticated: boolean;
    decodedToken: SsoToken | null;
    hasNext: boolean;
    keyCloak: KeyCloak | null;
    setAuthenticated: (val: boolean) => void;
    setCloak: (cloak: KeyCloak) => void;
    subject: string;
}

export const useAuthStore = create<AuthStore>((set) => ({
    authenticated: false,
    decodedToken: null,
    hasNext: false,
    keyCloak: null,
    setAuthenticated: (val) => set({ authenticated: val }),
    setCloak: (cloak) => set({ keyCloak: cloak, subject: cloak.subject }),
    subject: '',
}));
